import { ROUTES } from 'src/enums';

export default [
  {
    path: '/blog',
    meta: { auth: true, blog: true },
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: ':blogGuid/posts/:postGuid',
        component: () => import('layouts/PostEditLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.POSTS.EDIT,
            meta: { auth: true },
            component: () => import('pages/EditPostPage.vue'),
          },
        ],
      },
      {
        path: ':blogGuid/template',
        component: () => import('layouts/PostEditLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.BLOG_TEMPLATE,
            meta: { auth: true },
            component: () => import('pages/BlogTemplatePage.vue'),
          },
        ],
      },
      {
        path: '',
        component: () => import('layouts/MainLayout.vue'),
        children: [
          {
            path: ':blogGuid?',
            name: ROUTES.DASHBOARD,
            meta: { auth: true },
            component: () => import('pages/DashboardPage.vue'),
          },
          {
            path: ':blogGuid/posts',
            name: ROUTES.POSTS.INDEX,
            meta: { auth: true },
            component: () => import('pages/PostsPage.vue'),
          },
          {
            path: ':blogGuid/keywords',
            name: ROUTES.KEYWORDS,
            meta: { auth: true },
            component: () => import('pages/KeywordsPage.vue'),
          },
          {
            path: ':blogGuid/settings',
            name: ROUTES.BLOG_SETTINGS,
            meta: { auth: true },
            component: () => import('pages/BlogSettingsPage.vue'),
          },
        ],
      },
    ],
  },
];
